import React from 'react';
import { Gamepad2 } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Navbar() {
  return <nav className="fixed top-0 w-full z-50 border-b border-[#ffffff10] bg-[#050814]/80 backdrop-blur-md" data-id="element-63">
      <div className="container mx-auto px-6 h-20 flex items-center justify-between" data-id="element-64">
        <Link to="/" className="flex items-center gap-2 group" data-id="element-65">
          <Gamepad2 className="w-8 h-8 text-[#00f0ff] group-hover:text-[#ff006e] transition-colors duration-300" data-id="element-66" />
          <span className="text-2xl font-bold tracking-tighter font-['Orbitron']" data-id="element-67">
            CASINOLIVE<span className="text-[#ff006e]" data-id="element-68">.WEBSITE</span>
          </span>
        </Link>
        <div className="hidden md:flex items-center gap-8 font-mono text-sm" data-id="element-69">
          <Link to="/" className="hover:text-[#00f0ff] transition-colors" data-id="element-70">
            GAMES
          </Link>
          <Link to="/" className="hover:text-[#00f0ff] transition-colors" data-id="element-71">
            STUDIOS
          </Link>
          <Link to="/" className="hover:text-[#00f0ff] transition-colors" data-id="element-72">
            TECH
          </Link>
          <Link to="/privacy" className="hover:text-[#00f0ff] transition-colors" data-id="element-73">
            PRIVACY
          </Link>
          <button className="px-4 py-2 border border-[#ff006e] text-[#ff006e] hover:bg-[#ff006e] hover:text-white transition-all text-xs uppercase tracking-widest" data-id="element-74">
            Login
          </button>
        </div>
      </div>
    </nav>;
}